module.exports = __webpack_public_path__ + "static/media/index-shop-5.cb9fa905.webp";